module.exports = __webpack_public_path__ + "static/media/logo.989df413.svg";